import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Formik } from 'formik'
import React, { useState } from 'react'
import AppSubmit from './formik/AppSubmit'
import AppInput from './formik/AppInput'
import AppTextArea from './formik/AppTextArea'
import * as Yup from 'yup' 
import instance from '../api/client'
import { toast } from 'react-toastify'
import authService from '../authentication'


const validationSchema = Yup.object().shape({
  firstName: Yup.string().required().label("First name"),
  lastName: Yup.string().required().label("Last name"),
  projectCode: Yup.string().required().label("Project Code"),
  organization: Yup.string().required().label("Organization"),
  email: Yup.string().required().email().label("Email"),
});

export default function SendInviteModal({hidden, setHidden }) {
  const [lon, setLon] = useState(50.879)
  const [lat, setLat] = useState(4.6997)

  const onSubmit = async (form, { resetForm }) => {
    console.log(form);
    try {
      const {data, status } = await instance.post('/projects/send-invite', form, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if(status==200){
        toast.done(`Invite sent`, {
          position: toast.POSITION.TOP_CENTER
        });
        setHidden(true)
        resetForm();
      }else{
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
        toast.error(`Error: ${error}`, {
          position: toast.POSITION.TOP_CENTER
        });
    }
  };

  return (
      <div style={{display: hidden?'none':'flex'}} className='absolute z-50 flex w-full h-full items-center justify-center bg-modal'>
        <div className='bg-im2 shadow-lg rounded py-12'>
          <div className='w-full justify-end'>
            <div onClick={()=>setHidden(true)} className='mx-24 flex h-6 w-6 cursor-pointer justify-center items-center rounded border border-zinc-400 mb-6'>
              <FontAwesomeIcon icon={faClose} color='white' size='1x'/>
            </div>
          </div>
          <div className='max-h-[70vh] px-24 overflow-y-scroll'>
            <div className='text-d2 text-xl'>
              SEND INVITE 
            </div>
            <Formik
              initialValues={{email: '', firstName: '', lastName: '', organization: '', projectCode: ''}}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              >
                <>
              <div className=''>
                <div class="my-6 w-1/3">
                  <AppInput name={'projectCode'} label={'Project Code'} placeholder={'AB12'} type={'text'}/>
                </div>
                <div class="my-6 w-full grid grid-cols-2 gap-2">
                  <AppInput name={'firstName'} label={'first name'} placeholder={'John'} type={'text'}/>
                  <AppInput name={'lastName'} label={'last name'} placeholder={'Doe'} type={'text'}/>
                </div>
                <div class="my-6 w-full grid grid-cols-2 gap-2">
                  <AppInput name={'email'} label={'email'} placeholder={'someone@example.com'} type={'email'}/>
                  <AppInput name={'organization'} label={'organization'} placeholder={'My Organization'} type={'text'}/>
                </div>
              </div>
              <div className='mt-14'>
                <AppSubmit text={'Send'} />
              </div>
          </>
        </Formik>
        </div>
      </div>         
    </div>
  )
}
